// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.fade-enter-active[data-v-edfff5a4],
.fade-leave-active[data-v-edfff5a4] {
  transition: opacity 0.3s ease;
}
.fade-enter-from[data-v-edfff5a4],
.fade-leave-to[data-v-edfff5a4] {
  opacity: 0;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
